module.exports = __webpack_public_path__ + "static/media/SAWD.6a853c39.png";